import { sendTeaCommEvent } from 'lib/tea-analyze'
import { ArticleCardContext, getType } from 'Components/ugc/article-card'
import React, { useContext } from 'react'
import Toast from 'Components/toast-messager'

interface IProps {
  text: string
}

export default React.memo(({ text }: IProps) => {
  const { inheritNewCard, type: group_type, group_id, disabled } = useContext(
    ArticleCardContext
  )
  if (!text) {
    return null
  }
  return (
    <div className="ugc-text">
      {text.slice(0, 76)}
      {text.length > 76 && (
        <React.Fragment>
          <span>...</span>
          <span
            className="view-all"
            onClick={() => {
              if (disabled) {
                Toast.show({
                  text: '内容审核中',
                })
              }
              inheritNewCard &&
                sendTeaCommEvent('click_view_full_forum_content', {
                  group_type,
                  group_id,
                  content_type: getType(group_type),
                })
            }}
          >
            查看全文
          </span>
        </React.Fragment>
      )}

      <style jsx>
        {`
          .ugc-text {
            font-size: 16px;
            line-height: 28px;
            color: #333333;
            cursor: pointer;
          }
          .ugc-text a:hover {
            color: inherit;
          }
          span.view-all {
            margin-left: 4px;
            color: #205be6;
            font-size: 16px;
            line-height: 28px;
            transition: color 0.1s ease-in-out;
            cursor: pointer;
          }
        `}
      </style>
    </div>
  )
})
